import { makeStyles } from '@material-ui/core/styles';

// Use the dispatch map's Material UI typography and controls, not a new theme.
export const useStyles = makeStyles((theme) => ({
  overlay: { position: 'fixed', pointerEvents: 'none', zIndex: 800 },
  panel: {
    position: 'absolute', right: 12, bottom: 24, zIndex: 800,
    width: 370, maxWidth: 'calc(100% - 24px)', maxHeight: '65%',
    overflowY: 'auto', pointerEvents: 'auto', background: '#f8faf9', color: '#253b40',
    border: '1px solid #cbd9d7', borderRadius: 8,
    boxShadow: '0 4px 18px rgba(29, 56, 60, .16)',
    fontFamily: theme.typography.fontFamily, padding: 16,
    '& .MuiTypography-root': { fontFamily: theme.typography.fontFamily },
    [theme.breakpoints.down('sm')]: {
      bottom: 12, right: 12, width: 330, maxHeight: '48%', boxSizing: 'border-box',
    },
  },
  heading: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 },
  panelHeading: { flexWrap: 'wrap' },
  layerToggle: { margin: 0, '& .MuiFormControlLabel-label': { fontSize: 12, whiteSpace: 'nowrap' } },
  sizeToggle: {
    flexShrink: 0,
    '&:focus-visible, &.Mui-focusVisible': { outline: '3px solid #317c83', outlineOffset: 2 },
  },
  collapsed: {
    boxSizing: 'border-box', width: 'auto', padding: '4px 8px',
    maxHeight: 'none', overflow: 'visible',
    [theme.breakpoints.down('sm')]: { width: 'auto', maxHeight: 'none' },
  },
  section: { marginTop: 14 },
  muted: { color: '#536c71', fontSize: 12, lineHeight: 1.5 },
  stale: {
    background: '#fff0d5', borderLeft: '4px solid #a46110',
    padding: '8px 10px', marginTop: 10, fontWeight: 600,
  },
  warning: { color: '#895311', fontSize: 12, marginTop: 6 },
  legend: { display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 10, fontSize: 12 },
  swatch: { display: 'inline-block', width: 10, height: 10, borderRadius: 2, marginRight: 5 },
  list: { margin: '10px 0 0', padding: 0, listStyle: 'none' },
  row: {
    width: '100%', display: 'flex', justifyContent: 'space-between',
    textAlign: 'left', padding: '10px 8px', border: '1px solid #d9e3e1',
    borderRadius: 5, background: '#f2f6f5', color: 'inherit',
    cursor: 'pointer', marginBottom: 6, font: 'inherit',
    '&:hover': { background: '#e7efed' },
    '&:focus-visible': { outline: '3px solid #317c83', outlineOffset: 2 },
    '&[aria-pressed="true"]': { background: '#e2efed', borderColor: '#317c83' },
  },
  rowNumbers: { textAlign: 'right', maxWidth: '58%', marginLeft: 8, fontVariantNumeric: 'tabular-nums' },
  metrics: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, margin: '12px 0' },
  metric: {
    padding: 8, background: '#eaf1ef', borderRadius: 4,
    '& dt': { fontSize: 11, lineHeight: 1.4 },
    '& dd': { margin: '4px 0 0', fontSize: 20, fontWeight: 600, fontVariantNumeric: 'tabular-nums' },
  },
  detail: { borderTop: '1px solid #cbd9d7', marginTop: 14, paddingTop: 12 },
  definitions: {
    fontSize: 12, marginBottom: 0,
    '& dt': { color: '#536c71', marginTop: 7 },
    '& dd': { marginLeft: 0, fontWeight: 500, overflowWrap: 'anywhere' },
  },
  summary: { cursor: 'pointer', fontWeight: 600, padding: '6px 0' },
}));
